module.exports = __webpack_public_path__ + "img/why-keyapl-4.37f2422c.png";